import React, { useState } from 'react';
import { GraduationCap } from 'lucide-react';
export function DiscountBanner({
  onDiscountChange
}) {
  const [discounts, setDiscounts] = useState({
    collegiate: false
  });
  const handleDiscountToggle = discountType => {
    const newDiscounts = {
      ...discounts,
      [discountType]: !discounts[discountType]
    };
    setDiscounts(newDiscounts);
    onDiscountChange(newDiscounts);
  };
  return <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-6 mb-8 shadow-sm" data-id="element-169">
      <h3 className="text-lg font-semibold text-blue-900 mb-4" data-id="element-170">
        Special Discounts Available
      </h3>

      <div className="space-y-3" data-id="element-171">
        {/* Collegiate Discount */}
        <div className="flex items-start" data-id="element-172">
          <div className="flex items-center h-5 mt-1" data-id="element-173">
            <input id="collegiate-discount" type="checkbox" checked={discounts.collegiate} onChange={() => handleDiscountToggle('collegiate')} className="h-5 w-5 rounded border-blue-300 text-blue-600 focus:ring-blue-500" data-id="element-174" />
          </div>
          <div className="ml-3" data-id="element-175">
            <label htmlFor="collegiate-discount" className="font-medium text-blue-900 flex items-center cursor-pointer" data-id="element-176">
              <GraduationCap size={18} className="mr-2" data-id="element-177" />
              Collegiate Discount (10% off)
            </label>
            <p className="text-sm text-blue-700 mt-1" data-id="element-178">
              Available for college and university events
            </p>
          </div>
        </div>
      </div>
    </div>;
}